export default __webpack_public_path__ + "static/media/impale.ff30f8ec.png";